export default __webpack_public_path__ + "static/media/add_phrase-2.293f9269.png";